import { FirestoreEntity, Mapper, TimestampDtoToTimestampMapper } from '../../../@harmony';
import { Gallery, GalleryDto, GalleryEntity } from '../..';
import { Timestamp } from 'firebase/firestore';

export class GalleryToGalleryEntityMapper
  implements Mapper<Gallery, FirestoreEntity<GalleryEntity>>
{
  public map(from: Gallery): FirestoreEntity<GalleryEntity> {
    return new FirestoreEntity(from.id, {
      _version: 0,
      slug: from.slug,
      title: from.title,
      description: from.description,
      teamId: from.teamId,
      createdBy: from.createdBy,
      createdAt: Timestamp.fromDate(from.createdAt),
      updatedAt: Timestamp.fromDate(from.updatedAt),
      itemIds: [...from.itemIds],
      coverItemId: from.coverItemId,
      publicPasswordHash: from.publicPasswordHash,
      publicPassword: from.publicPassword,
      contributorUserIds: from.contributorUserIds.length ? [...from.contributorUserIds] : undefined,
      isOpenToTeam: from.isOpenToTeam || undefined,
      expiresAt: from.expiresAt ? Timestamp.fromDate(from.expiresAt) : undefined,
    });
  }
}

export class GalleryDtoToGalleryEntityMapper
  implements Mapper<GalleryDto, FirestoreEntity<GalleryEntity>>
{
  private readonly timestampMapper = new TimestampDtoToTimestampMapper();

  public map(from: GalleryDto): FirestoreEntity<GalleryEntity> {
    return {
      id: from.id,
      data: {
        ...from.data,
        createdAt: this.timestampMapper.map(from.data.createdAt),
        updatedAt: this.timestampMapper.map(from.data.updatedAt),
        expiresAt: from.data.expiresAt ? this.timestampMapper.map(from.data.expiresAt) : undefined,
      },
    };
  }
}

export class GalleryEntityToGalleryMapper
  implements Mapper<FirestoreEntity<GalleryEntity>, Gallery>
{
  public map(from: FirestoreEntity<GalleryEntity>): Gallery {
    return new Gallery(
      from.id,
      from.data.slug,
      from.data.title,
      from.data.description,
      from.data.teamId,
      from.data.createdBy,
      from.data.createdAt.toDate(),
      from.data.updatedAt.toDate(),
      from.data.itemIds ?? [],
      from.data.coverItemId,
      from.data.publicPasswordHash,
      from.data.publicPassword,
      from.data.contributorUserIds ?? [],
      from.data.isOpenToTeam ?? false,
      from.data.expiresAt ? from.data.expiresAt.toDate() : undefined,
    );
  }
}
